import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 220 220",
  class: "ring-svg",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "ring-copy" }
const _hoisted_3 = { class: "ring-number" }
const _hoisted_4 = { class: "ring-signal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ai-progress-ring", `ai-progress-ring--${_ctx.state}`])
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "ring-halo ring-halo--outer" }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "ring-halo ring-halo--inner" }, null, -1)),
    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
      _cache[0] || (_cache[0] = _createStaticVNode("<defs data-v-94b1587c><linearGradient id=\"aiRingGradient\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"100%\" data-v-94b1587c><stop offset=\"0%\" stop-color=\"#eaf4ff\" data-v-94b1587c></stop><stop offset=\"28%\" stop-color=\"#9db8ff\" data-v-94b1587c></stop><stop offset=\"62%\" stop-color=\"#5b8cff\" data-v-94b1587c></stop><stop offset=\"100%\" stop-color=\"#72d8ff\" data-v-94b1587c></stop></linearGradient></defs><circle class=\"ring-track\" cx=\"110\" cy=\"110\" r=\"84\" data-v-94b1587c></circle><circle class=\"ring-markers\" cx=\"110\" cy=\"110\" r=\"92\" data-v-94b1587c></circle>", 3)),
      _createElementVNode("circle", {
        class: "ring-progress",
        cx: "110",
        cy: "110",
        r: "84",
        style: _normalizeStyle(_ctx.progressStyle)
      }, null, 4)
    ])),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.progress), 1),
        _cache[1] || (_cache[1] = _createElementVNode("small", null, "%", -1))
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.caption), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (bar) => {
          return _createElementVNode("i", { key: bar })
        }), 64))
      ])
    ])
  ], 2))
}